import React from 'react';
import './App.css';
import Login from './Login';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Conversation Dashboard</h1>
      </header>
      <Login />
    </div>
  );
}

export default App;
